﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class CompanyClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAll() {
        return this.client.apiCompaniesGet();
    }
    getAllSystemCompanies() {
        return this.client.apiCompaniesAllGet();
    }
}
exports.CompanyClient = CompanyClient;
//# sourceMappingURL=CompanyClient.js.map